export enum TransferType {
  Internal = 'internal',
  Sweep = 'sweep',
}
